export default __webpack_public_path__ + "static/media/Bracers of the Eternal Blaze.d2203ea4.jpg";